const ex = require('../lib/error')

const checkExportFileKey = async (req, res, next) => {
    const key = req.params.key
    if (!key || key !== process.env.EXPORT_KEY) {
        return ex.raiseError(req, res, "MAUD008", 400, "Wrong key")
    }
    next()
}

module.exports = {
    checkExportFileKey
}